import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, ShoppingBag } from 'lucide-react';

export default function ArtikelRamadanLichterDeko() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Ramadan Lichter & Mond-Dekoration: Wo kaufen?</h1>
          <p className="text-lg text-white/80 leading-relaxed">Die besten Quellen für Ramadan- und Eid-Dekoration in Deutschland.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Lichter, Laternen und Mond-Dekoration gehören zum Ramadan wie der Mond zum Himmel. Hier erfährst du, wo du in Deutschland die schönste Ramadan-Deko findest – online und offline.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><ShoppingBag className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Online-Shops</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Amazon</h4>
                <p className="text-sm text-[#4B5563] mb-2">Größte Auswahl, schnelle Lieferung. Suche nach "Ramadan Deko", "Eid Dekoration", "Mond Lichterkette".</p>
                <p className="text-sm text-[#4A5D4F]">✓ Prime-Versand ✓ Große Auswahl ✓ Kundenbewertungen</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Etsy</h4>
                <p className="text-sm text-[#4B5563] mb-2">Handgemachte und einzigartige Stücke. Besonders schön für individuelle Dekoration.</p>
                <p className="text-sm text-[#4A5D4F]">✓ Handgemacht ✓ Personalisierbar ✓ Einzigartig</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Islamische Online-Shops</h4>
                <p className="text-sm text-[#4B5563] mb-2">Spezialisierte Shops mit authentischer Ramadan-Deko: Muslim-Shop.de, Orientbazar24, etc.</p>
                <p className="text-sm text-[#4A5D4F]">✓ Spezialisiert ✓ Authentisch ✓ Oft aus DE versendet</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">AliExpress (mit Vorlauf)</h4>
                <p className="text-sm text-[#4B5563] mb-2">Sehr günstig, aber 2-4 Wochen Lieferzeit. Früh bestellen!</p>
                <p className="text-sm text-[#4A5D4F]">✓ Sehr günstig ✗ Lange Lieferzeit</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Lokale Geschäfte</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Action, Tedi, NanuNana</h4>
                <p className="text-sm text-[#4B5563]">Basics wie goldene Lichterketten, Kerzen, Luftballons. Nicht speziell islamisch, aber vielseitig einsetzbar.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Türkische/Arabische Supermärkte</h4>
                <p className="text-sm text-[#4B5563]">Vor Ramadan oft Saisonware: Laternen, Banner, Girlanden. Authentisch und günstig!</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Orientalische Geschäfte</h4>
                <p className="text-sm text-[#4B5563]">In größeren Städten: Laternen, Räuchergefäße, Teekannen – ganzjährig verfügbar.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">IKEA</h4>
                <p className="text-sm text-[#4B5563]">Laternen (BORRBY, ROTERA), Lichterketten, Kerzenhalter – neutral, aber stilvoll.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Depot, Butlers</h4>
                <p className="text-sm text-[#4B5563]">Elegante Deko, die zur Eid-Ästhetik passt: Goldene Kerzenständer, Vasen, Tischdecken.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Was kaufen?</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Must-Haves</h4>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>✓ Mond-Lichterkette</li>
                  <li>✓ "Eid Mubarak"-Banner</li>
                  <li>✓ Goldene/silberne Luftballons</li>
                  <li>✓ Laterne mit LED-Kerze</li>
                  <li>✓ Tischkonfetti</li>
                </ul>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Nice-to-Have</h4>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>• Holz-Deko (Mond/Moschee)</li>
                  <li>• Stoffgirlanden</li>
                  <li>• Tischläufer</li>
                  <li>• Serviettenringe</li>
                  <li>• Türkranz</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Budget-Tipps</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Früh kaufen:</strong> Vor Ramadan sind die Preise niedriger und die Auswahl besser</li>
                <li><strong>Wiederverwendbar:</strong> In Qualität investieren, die mehrere Jahre hält</li>
                <li><strong>DIY kombinieren:</strong> Basics kaufen, Rest selbst basteln</li>
                <li><strong>Nachbarn fragen:</strong> Zusammen bestellen spart Versand</li>
                <li><strong>Nach Eid kaufen:</strong> Für nächstes Jahr – oft 50% reduziert!</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Ramadan-Dekoration ist heute leichter zu finden als je zuvor. Ob online oder lokal, günstig oder premium – für jeden Geschmack und jedes Budget gibt es die passende Deko!</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Ramadan Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/eid-deko-ideen" className="text-[#4A5D4F] hover:underline">→ Eid Deko Ideen für Zuhause</Link></li>
              <li><Link to="/ratgeber/diy-eid-tischdeko" className="text-[#4A5D4F] hover:underline">→ DIY Eid Tischdeko</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
